import { Breadcrumbs } from "@/components";
import { CoordSetAndLook } from "@/components/CoordSetAndLook";
import Layout from "@/layout";
import { buildPageProps } from "@/lib/ssg/slug";
import { breadcrumbArray } from "@jog/react-components";
import { buildShopTheLookPage as buildShopTheLookPageBase, prismicClient } from "@jog/shared";
import { getNotFoundProps } from "../notFound";
export const buildShopTheLookPage = async (redisItem, pageContext) => {
    try {
        const client = prismicClient({ previewData: pageContext.previewData });
        const pageProps = await buildShopTheLookPageBase(client, redisItem);
        return buildPageProps(pageContext, pageProps);
    }
    catch (e) {
        console.error(e);
        return getNotFoundProps(pageContext);
    }
};
export const ShopTheLookDetailPageContent = ({ page }) => {
    const breadcrumb = breadcrumbArray(page.path.split("/"));
    return (<Layout>
            <Breadcrumbs list={breadcrumb}/>
            <CoordSetAndLook prismic={page.prismic.data} products={page.products} last={breadcrumb.at(-2)}/>
        </Layout>);
};
